<template>
  <div class='container container-small container-padded-small order show-order'>
    <h2>Order Confirmed</h2>
    <div class='line' />

    <div class='row'>
      <div class='col l6'>
        <h3>ORDER DATE</h3>
        <div class='field'>{{ order.created_at }}</div>

        <h3>ORDER NUMBER</h3>
        <div class='field'>{{ order.uid }}</div>

        <h3>ORDER STATUS</h3>
        <div class='field'>{{ order.status }}</div>

        <h3>PAYMENT METHOD</h3>
        <div class='field'>{{ order.card.brand }} ending in {{ order.card.last_4 }}</div>
      </div>

      <div class='col l6'>
        <h3>CUSTOMER INFORMATION</h3>
        <div class='field'>{{ order.email }}</div>
        <div class='field'>{{ order.phone_number }}</div>

        <h3>SHIPPING ADDRESS</h3>
        <div class='field'>{{ order.shipping_address.name }}</div>
        <div class='field'>{{ order.shipping_address.address_1 }}</div>
        <div class='field' v-if='order.shipping_address.address_2'>{{ order.shipping_address.address_2 }}</div>
        <div class='field'>{{ order.shipping_address.city }}, {{ order.shipping_address.state }} {{ order.shipping_address.zipcode }}</div>
        <div class='field'>{{ order.shipping_address.country }}</div>
      </div>
    </div>

    <div v-if='order.status !== "Canceled"'>
      <br /><br />
      <table>
        <thead>
          <tr>
            <th class='text-left'>ITEM</th>
            <th class='price'>QUANTITY</th>
            <th class='price'>PRICE</th>
          </tr>
        </thead>

        <tbody>
          <tr v-for='line_item in order.line_items'>
            <td>
              <b>{{line_item.description}}</b>
              <div class='field'>${{line_item.price}}</div>
            </td>
            <td class='quantity'>{{line_item.quantity}}</td>
            <td class='price'>{{format_currency(line_item.price * line_item.quantity)}}</td>
          </tr>
          <tr>
            <td></td>
            <td class='price'>Subtotal</td>
            <td class='price'>{{ format_currency(order.subtotal) }}</td>
          </tr>
          <tr>
            <td></td>
            <td class='price'>Shipping</td>
            <td class='price'>{{ format_currency(order.shipping) }}</td>
          </tr>
          <tr v-if='order.taxable'>
            <td></td>
            <td class='price'>Tax</td>
            <td class='price'>{{ format_currency(order.sales_tax) }}</td>
          </tr>
          <tr>
            <td></td>
            <td class='price'>Total</td>
            <td class='price'>{{ format_currency(order.total) }}</td>
          </tr>
        </tbody>
      </table>

      <p>Need to change your shipping address or your camera selection? Have other questions? Email <a href="mailto:help@witharsenal.com">help@witharsenal.com</a> or go to our <a href="/contact">Contact Us</a> page.</p>

      <br />

      <div v-if ="order.editable">
        <a :href='`/order/${order.uid}/edit`'>Edit Order</a>
        <template v-if='order.cancelable'>
          |
          <a @click.prevent='open_cancel_modal' href=''>Cancel Order</a>
        </template>

        <br /><br />
        <p class='small'>
          Order's may be edited or canceled at any time prior to being shipped. Refunds or additional charges will show up on your credit card statement within a few business days.
        </p>
      </div>
    </div>

    <transition name='modal'>
      <div v-if='modal' class='modal-wrapper'>
        <div class='modal'>
          <div class='modal-body'>
            <p>Are you sure you want to cancel your order?</p>
          </div>

          <div class='modal-actions'>
            <a @click.prevent='close_cancel_modal' class='btn btn-cancel'>Don't Cancel Order</a>
            <spinner-button @click.native='cancel' :spin='submitting' class='btn'>Cancel Order</spinner-button>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
  import SpinnerButton from 'app/components/shared/SpinnerButton'
  import includes from 'lodash/includes'
  import { format_currency } from 'app/helpers/CurrencyHelpers'

  export default {
    props: ['order'],
    mounted () {
      if (includes(window.location.search, 'from_update=true')) {
        this.$toast("Order updated successfully.", { horizontalPosition: 'center', verticalPosition: 'top', duration: 10000 })
      }

      if (includes(window.location.search, 'confirmed=true')) {
        this.$toast("Thank you for confirming your order.", { horizontalPosition: 'center', verticalPosition: 'top', duration: 10000 })
      }
    },
    data () {
      return {
        modal: false,
        submitting: false
      }
    },
    methods: {
      format_currency,
      open_cancel_modal () {
        this.modal = true
      },
      close_cancel_modal () {
        this.modal = false
      },
      cancel () {
        this.submitting = true

        this.$http.delete(`/orders/${this.order.uid}`).then(response => {
          this.submitting = false
          this.modal = false
          this.order.status = 'Canceled'
          let message = "Your order has been cancelled."
          this.$toast(message, { horizontalPosition: 'center', verticalPosition: 'top' })

          Intercom('trackEvent', 'order-cancelled', {
            order_id: response.body.id,
            total: `$${response.body.total}`,
            link: `${window.location.origin}/order/${response.body.uid}`
          })
        }, response => {
          this.submitting = false
          let error = response.body.error || 'Something went wrong.  Please try again or contact support.'
          if (error) this.modal = false
          this.$toast(error, { horizontalPosition: 'center', verticalPosition: 'top' })
        })
      }
    },
    components: { SpinnerButton }
  }
</script>
